export default __webpack_public_path__ + "static/media/xyo.4d47624f.svg";